import { UK_ISO_CODE, US_ISO_CODE, FR_ISO_CODE, IE_ISO_CODE } from 'components/Address/util';

import {
  zipCodeValidator,
  ukPostcodeValidator,
  usZipCodeValidator,
  frPostcodeValidator,
  iePostcodeValidator,
} from './validator';

export default value => {
  switch (value) {
    case UK_ISO_CODE:
      return ukPostcodeValidator;
    case US_ISO_CODE:
      return usZipCodeValidator;
    case FR_ISO_CODE:
      return frPostcodeValidator;
    case IE_ISO_CODE:
      return iePostcodeValidator;
    default:
      return zipCodeValidator;
  }
};
